import { debug } from '@shared/helpers/debug';

export const required_recipient = {
  validate: value => {
    if (value) {
      if (value.recipients && value.include) {
        const is_recipients = Array.isArray(value.recipients) && value.recipients.length > 0;
        const is_includes = Array.isArray(value.include) && value.include.length > 0;
        return is_recipients || is_includes;
      } else {
        debug.warn('required_recipient: not keys recipients, include', value);
      }
    } else {
      debug.warn('required_recipient: empty value', value);
    }

    return false;
  }
};
